import { render, staticRenderFns } from "./email_reg.vue?vue&type=template&id=e7409e7a"
import script from "./email_reg.vue?vue&type=script&lang=js"
export * from "./email_reg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports